<template>
  <div id="app">
					<div class="text">
            <div class="container">
            <div class="row">
              <div class="col-md-3" style="text-align:left;">
 <b><label>Dátum od:</label></b>
<datetime type="date" v-model="dateFrom"></datetime>
</div>

<div class="col-md-3" style="text-align:left;">
  <b><label>Dátum do</label></b>
<datetime type="date" v-model="dateTo"></datetime>

  </div>

<div class="col-md-3" style="text-align:left;">
  <b><label>Projekt {{project}}</label></b>
<select class="form-control" id="sel1" v-model="project">
  <option value="all">Všetky</option>
    <option v-for="p in projects" :key="p.id">{{p.name}}</option>
  </select>  </div>


<div class="col-md-2" style="text-align:left;">
  <b><label>Užívateľ</label></b>
<select class="form-control" id="sel1" v-model="user">
    <option v-for="(user, index) in users" :key="index" :value="user.email">{{user.firstname}} {{user.lastname}}</option>
  </select>  

  </div>
  

  <div class="col-md-1" style="text-align:left;margin-top:30px;">
						<button type="button" href="#" class="txt2 hov1 btn btn-primary" @click="load">
							Načítaj
						</button>
          </div>


</div>
<hr>
<div class="container">
  <h2>Výsledky</h2>  <button type="button" href="#" class="txt2 hov1 btn btn-success" @click="save" :disabled="range.length == 0 || $store.getters.user.role == 'moderator'">
							Uložiť
						</button>
  <table class="table table-striped" style="text-align:left">
    <thead style="text-align:left">
      <tr style="text-align:left">
        <th style="text-align:left">Začiatok</th>
        <th>Koniec</th>
        <th>Projekt</th>
        <th>Štart KM</th>
        <th>Koniec KM</th>
        <th>Akcia</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(day, index) in this.range" :key="index">
        <td><datetime type="datetime" v-model="day.begin"></datetime></td>
        <td><datetime type="datetime" v-model="day.end"></datetime></td>
        <td>{{day.project}}</td>
        <td v-if="day.type == 'drive'"><input type="text" v-model="day.start_km"></td><td v-else>--</td>
        <td v-if="day.type == 'drive'"><input type="text" v-model="day.end_km"></td><td v-else>--</td>
        <td><button class="btn btn-danger" @click="deleteDocument(day.doc.id)">Zmazať</button></td>
      </tr>
    </tbody>
  </table>
<hr>
<p><b>Spolu odpracované:</b> {{secondsToHms(totalSeconds)}}</p>
<p><b>Spolu najazdených:</b> {{totalKm}} kilometrov</p>
</div>


</div>
					</div>
  </div>
</template>

<script>
import '../vendor/bootstrap/css/bootstrap.min.css'
import '../fonts/Linearicons-Free-v1.0.0/icon-font.min.css'
import '../vendor/bootstrap/css/bootstrap.min.css'
import '../vendor/jquery/jquery-3.2.1.min.js'
import firebase from 'firebase'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker';
import navbar from './components/Navbar.vue'
import Vue from 'vue'

export default {
  components : {
    Datepicker
  },
  name: 'Tracker',
  data() {
    return {
      project : "",
      projects : [],
      dateFrom : '',
      dateTo : '',
      user : '',
      users : [],
      result : [],
      totalSeconds : 0,
      totalHours : "",
      totalKm : 0,
      range : []
    }
  },
  methods : {
    async getUsers()
    {
            await firebase.firestore().collection('user').get().then(snap => {
        if(!snap.empty)
        {
          console.log("snap not empty");
          this.users = snap.docs.map(x => x.data());
        }
        });
    },  
    async deleteDocument(id)
    {
      console.log("deleting " + id);
      var toast = this.$toast;
      const res = await firebase.firestore().collection('timer').doc(id).delete().then( res => {
        console.log("ok");
        toast.success('Dokument úspešne zmazaný.', { position:'top' });
      }).catch(e => {

        toast.error('Dokument sa nepodarilo zmazať.', { position:'top' });
      });

      this.load();
    },
    secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " hodina, " : " hodín, ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " minúta, " : " minút, ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " sekunda" : " sekúnd") : "";
    return hDisplay + mDisplay + sDisplay; 
},

    async getProjects()
    {
            await firebase.firestore().collection('project').get().then(snap => {
        if(!snap.empty)
        {
          console.log("snap not empty");
          this.projects = snap.docs.map(x => x.data());
        }
        });
    },
    dateChange()
    {
      console.log("wat");
      console.log(this.dateFrom);
    },
    getDates(startDate, stopDate) {
    var dateArray = new Array();
    var currentDate = startDate;
    while (currentDate <= stopDate) {
        dateArray.push(new Date (currentDate));
        currentDate = currentDate.addDays(1);
    }
    return dateArray;
},
    async save()
    {
      this.range.forEach(d => {
        console.log("updating " + d.doc.id);
        if(!d.end_km)
          d.end_km = 0;

        if(!d.start_km)
          d.start_km = 0;

        d.doc.ref.update({begin : new Date(d.begin), end : new Date(d.end), start_km : d.start_km, end_km : d.end_km});
      });      
    },
    async load()
    {
      this.range = [];
      let modifiedFrom = moment(this.dateFrom);
      modifiedFrom.set({h:0,m:0,s:1});

      let modifiedTo = moment(this.dateTo);
      modifiedTo.set({h:23,m:59,s:59});
  if(this.project == 'all')
  {
      console.log("begin > " + modifiedFrom.toDate() + " | begin < " + modifiedTo.toDate() + " | user " + this.user);
        firebase.firestore().collection('timer').where('email', '==', this.user).
        where('begin', '>', modifiedFrom.toDate()).where('begin', '<', modifiedTo.toDate()).get().then(async data => {
          console.log("DATA!");
          console.log(data.docs);
          //this.range = data.docs.map(x=>x.data());
          data.docs.forEach(d => {
            if(d.data().begin != null & d.data().end != null)
            {
              console.log("pushing " + d.id + " with begin " + new Date(d.data().begin.seconds).toString());
              this.range.push({
                id : d.id,
                begin : moment(new Date(d.data().begin.seconds * 1000)).toISOString(),
                end : moment(new Date(d.data().end.seconds * 1000)).toISOString(),
                start_km : d.data().start_km,
                end_km : d.data().end_km,
                project : d.data().project,
                type : d.data().type,
                doc : d
              });
            }
          });
        });
  }
  else
  {
          console.log("begin > " + modifiedFrom.toDate() + " | begin < " + modifiedTo.toDate() + " | user " + this.user);
        firebase.firestore().collection('timer').where('email', '==', this.user).
        where('begin', '>', modifiedFrom.toDate()).where('begin', '<', modifiedTo.toDate()).where('project', '==', this.project).get().then(async data => {
          console.log("DATA!");
          console.log(data.docs);
          //this.range = data.docs.map(x=>x.data());
          data.docs.forEach(d => {
            if(d.data().begin != null & d.data().end != null)
            {
              console.log("pushing " + d.id + " with begin " + new Date(d.data().begin.seconds).toString());
              this.range.push({
                id : d.id,
                begin : moment(new Date(d.data().begin.seconds * 1000)).toISOString(),
                end : moment(new Date(d.data().end.seconds * 1000)).toISOString(),
                start_km : d.data().start_km,
                end_km : d.data().end_km,
                project : d.data().project,
                type : d.data().type,
                doc : d
              });
            }
          });
        });
  }



    }
  },
  created()
  {

    

    this.getProjects();
    this.getUsers();
    console.log("tracker!");

    
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
